import { useNavigate } from "react-router-dom";

const INTENTS = [
  { key: "monitor_partner", label: "Check my partner", icon: "💔" },
  { key: "monitor_crush", label: "Check my crush", icon: "💕" },
  { key: "monitor_friend", label: "Check a friend", icon: "👯" },
  { key: "monitor_self", label: "Track my own profile", icon: "👤" },
  { key: "curiosity", label: "Just curious", icon: "👀" },
  { key: "other", label: "Other reason", icon: "🤔" },
];

export function OnboardingUsageIntentPage() {
  const navigate = useNavigate();

  const handleSelect = (_intent: string) => {
    // Analytics: PostHog event would go here
    navigate("/onboarding/target");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #fdf2f2 0%, #ffffff 100%)",
        padding: "24px",
      }}
    >
      <div style={{ maxWidth: "360px", width: "100%", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "1.5rem",
            fontWeight: 800,
            color: "#171717",
            marginBottom: "8px",
          }}
        >
          What brings you to Stalkie?
        </h1>
        <p style={{ color: "#737373", marginBottom: "32px", fontSize: "0.9375rem" }}>
          This helps us tailor your experience.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {INTENTS.map((intent) => (
            <button
              key={intent.key}
              onClick={() => handleSelect(intent.key)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "14px 16px",
                background: "white",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                borderRadius: "14px",
                cursor: "pointer",
                textAlign: "left",
                fontSize: "0.9375rem",
                fontWeight: 600,
                color: "#171717",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "#ff6b8a";
                (e.currentTarget as HTMLButtonElement).style.background = "#fdf2f2";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "rgba(15, 23, 42, 0.08)";
                (e.currentTarget as HTMLButtonElement).style.background = "white";
              }}
            >
              <span style={{ fontSize: "24px" }}>{intent.icon}</span>
              {intent.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
